import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app/App'
import { Providers } from './app/providers'
import { registerServiceWorker } from './lib/register-sw'
import './app/globals.css'

// Persistent storage for the offline working set (D24) — request early.
if (typeof navigator !== 'undefined' && navigator.storage?.persist) {
  void navigator.storage.persist()
}

// Replaces vite-plugin-pwa's injected registerSW.js (injectRegister: null) so
// the worker is registered with `updateViaCache: 'none'`.
registerServiceWorker()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root element missing from index.html')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
)
